import React from 'react';

export default function RootPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <img src="/public/beechppc-logo.png" alt="Beech PPC" className="h-12 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Client Reporting Portal</h1>
        <p className="text-gray-500 mb-8">
          Access your Google Ads dashboard using the link provided by your account manager.
        </p>
        <a
          href="https://www.beechppc.com"
          className="inline-block px-6 py-2.5 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Visit beechppc.com
        </a>
      </div>
    </div>
  );
}
